import {AJAX_FINISHED, AJAX_IN_PROGRESS} from "../services/config";
import axios from "axios";
import http_build_query from "locutus/php/url/http_build_query";


export const getAjaxData = (route, type, data) => dispatch => {

    if (data.hasOwnProperty('downloadFile') && data.downloadFile) {
        window.open(route + '?' + http_build_query(data), '_blank');
    } else if (data.hasOwnProperty('downloadCSV') && data.downloadCSV) {
        window.open(route + '?' + http_build_query(data), '_blank');
    } else {
        dispatch({
            type: type + '_LOADING',
            payload: AJAX_IN_PROGRESS
        });

        axios.get(route + '?' + http_build_query(data))
            .then(res => res.data)
            .then(res => {
                dispatch({
                    type: type,
                    payload: res
                })
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });
            })
    }

}

export const getAjaxDataById = (id, route, type, data) => dispatch => {

    if (
        (data.hasOwnProperty('downloadCSV') && !data.downloadCSV) ||
        !data.hasOwnProperty('downloadCSV')
    ) {
        dispatch({
            type: type + '_LOADING',
            payload: AJAX_IN_PROGRESS
        });

        axios.get(route + '/' + id + '?' + http_build_query(data))
            .then(res => res.data)
            .then(res => {
                dispatch({
                    type: type,
                    payload: res
                })
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });
            })
    } else if (data.hasOwnProperty('downloadCSV') && data.downloadCSV) {
        window.open(route + '?' + http_build_query(data), '_blank');
    }

}

export const postAjaxData = (route, type, data) => dispatch => {

    dispatch({
        type: type + '_LOADING',
        payload: AJAX_IN_PROGRESS
    });

    if (data.hasOwnProperty('file')) {
        let formData = new FormData();

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        for (let key in data) {
            formData.append(key, data[key]);
        }

        axios.post(route, formData, config)
            .then(res => res.data)
            .then(res => {
                dispatch({
                    type: type,
                    payload: res
                })
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });
            })
            .catch(error => {
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });

                if (
                    error &&
                    error.response &&
                    error.response.hasOwnProperty('data')
                ) {
                    dispatch({
                        type: type + '_ERROR',
                        payload: error.response.data
                    });
                }

            })

    } else {
        axios.post(route, {
            ...data
        })
            .then(res => res.data)
            .then(res => {
                dispatch({
                    type: type,
                    payload: res
                })
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });
            })
            .catch(error => {
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });

                if (
                    error &&
                    error.response &&
                    error.response.hasOwnProperty('data')
                ) {
                    dispatch({
                        type: type + '_ERROR',
                        payload: error.response.data
                    });
                }

            })
    }

}

export const patchAjaxData = (route, type, id, data) => dispatch => {

    dispatch({
        type: type + '_LOADING',
        payload: AJAX_IN_PROGRESS
    });

    if (data.hasOwnProperty('file')) {
        let formData = new FormData();

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        for (let key in data) {
            formData.append(key, data[key]);
        }

        axios.post(route + '/' + id, formData, config)
            .then(res => res.data)
            .then(res => {
                dispatch({
                    type: type,
                    payload: res
                })
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });
            })

    } else {

        let routeWithId = '';
        if (id !== null) {
            routeWithId = '/' + id
        }

        axios.patch(route + routeWithId, {
            ...data
        })
            .then(res => res.data)
            .then(res => {
                dispatch({
                    type: type,
                    payload: res
                })
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });
            })
            .catch(error => {
                dispatch({
                    type: type + '_LOADING',
                    payload: AJAX_FINISHED
                });

                if (
                    error &&
                    error.response &&
                    error.response.hasOwnProperty('data')
                ) {
                    dispatch({
                        type: type + '_ERROR',
                        payload: error.response.data
                    });
                }

            })
    }

}

export const deleteAjaxData = (route, type, id) => dispatch => {

    dispatch({
        type: type + '_LOADING',
        payload: AJAX_IN_PROGRESS
    });


    let routeWithId = '';
    if (id !== null) {
        routeWithId = '/' + id
    }

    axios.delete(route + routeWithId)
        .then(res => res.data)
        .then(res => {
            dispatch({
                type: type,
                payload: res
            })
            dispatch({
                type: type + '_LOADING',
                payload: AJAX_FINISHED
            });
        })

}

export const updateAjaxLoadingStatus = (type, status) => dispatch => {

    dispatch({
        type: type,
        payload: status
    })

}

export const updateState = (type, payload) => dispatch => {

    dispatch({
        type,
        payload
    })

}

